<app-header></app-header>

<h1 class="main-title" id="security">Security</h1>

<!-- Content -->
<section class="section terms">
  <div class="container container__short">
    <div class="legal-copy pb-5">
      <p>Have you spotted a security vulnerability?</p>
      <p>Email us at: <a href="mailto:info@ukcc.co.uk">info&#64;ukcc.co.uk</a>.</p>
      <p>If you’ve identified a security vulnerability impacting {{brandName}}, please feel free to let us know by email as soon as you can:</p>
      <p>You will need to include your name and contact details.</p>
      <p>Please include as much evidence as you can.</p>
      <p>We take all reports extremely seriously and will investigate them fully, and if necessary call the authorities.</p>
      <p>Due to the volume of correspondence we receive including hoax reports, we do not engage with anonymous reports on a one to one basis.</p>
    </div>
  </div>
</section>

<app-footer></app-footer>
